import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiWalletTransactionsList } from 'Services/UserService'
import { getFinancialYearDates } from 'Utils/helper'

export const getData = createAsyncThunk('user/walletTransactions/getData', async datas => {
    const { data } = await apiWalletTransactionsList(datas)
    return data
})

export const getView = createAsyncThunk('user/walletTransactions/getView', async id => {
    return viewData
})

const viewData = {
    types: '',
    user_id: '',
    bank_account_id: '',
    store_bank_account_id: '',
    unpaid_invoices: [],
    amount: '',
    description: '',
    type: '',
}

export const walletTransactionsSlice = createSlice({
    name: 'user/walletTransactions',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            ...getFinancialYearDates(),
            user_type: '',
            user_id: '',
            store_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setUserType: (state, { payload }) => {
            state.table.page = 1
            state.table.user_type = payload
            state.table.user_id = ''
        },
        setUserId: (state, { payload }) => {
            state.table.page = 1
            state.table.user_id = payload
        },
        setStoreId: (state, { payload }) => {
            state.table.page = 1
            state.table.user_id = ''
            state.table.store_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setUserType, setUserId, setStoreId } = walletTransactionsSlice.actions

export default walletTransactionsSlice.reducer
